<label class="kt-form-label font-medium text-xs mb-1">
  {{ field.label }}
</label>

<input
  type="number"
  class="kt-input"
  [step]="decimalScale === 0 ? 1 : '0.01'"
  [formControl]="control" />